<div class="review">
    <div class="reviewHeadline">
        <h3>{{ review.headline }}</h3>
        <app-star [rating]="review.stars" [bigger]="true"></app-star>
    </div>
    <div class="hr-line"></div>

    <span *ngIf="review.showComplete" class="feedback">{{ review.reviewText }}</span>
    <span *ngIf="!review.showComplete" class="feedback">{{ review.shortReviewText }}</span>
    <!-- <span>{{ review.reviewText }}</span> -->

    <div class="column1">
        <button  matButton="elevated" color="accent" *ngIf="review.hasLongDescription" class="btn_green showMoreLess" (click)="
                review.showComplete =
                    !review.showComplete
            ">
            {{ review.showComplete? 'Weniger anzeigen': 'Mehr anzeigen'}}
        </button>
    </div>

    <div class="reviewFooter">
        <span matTooltip="Upvotes für diese Bewertung" matTooltipClass="header-tooltip" matTooltipPosition="above"
            style="cursor: pointer;" *ngIf="review.upvotes?.length === undefined">{{ review.upvotes }}
            {{ review.upvotes == 1 ? 'Upvote' : 'Upvotes' }}</span>
        <span *ngIf="review.reviewType === reviewTypeEnum.PRODUCT_REVIEW" class="reviewLink"
            (click)="navigateToProduct(review.targetId)">Zum Produkt</span>
        <span *ngIf="review.reviewType === reviewTypeEnum.ORGANISATION_REVIEW" class="reviewLink"
            (click)="navigateToOrganisation(review.targetName)">Zur Organisation</span>
    </div>
</div>